var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"impact-column"},[_c('ui-badge',{attrs:{"label":_vm.label,"color":_vm.color,"fill":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }